import React from "react";
import { useFormContext } from "react-hook-form";

import TextField from "components/common/Text";
import TextCheckBox from "components/common/TextCheckBox";

import { formatFinanceAdjustmentAmount } from "util/financeAdjustment";

import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

import "./FinanceAdjustmentFields.scss";

// This common component is an untyped .jsx file whose destructured props without defaults read as required in TS.
type LooseProps = Record<string, unknown>;
const Text = TextField as React.ComponentType<LooseProps>;

type FinanceAdjustmentFieldsProps = {
  adjustInvoice: boolean;
  onToggle: (checked: boolean) => void;
  adjustmentAmount: number | null;
};

function FinanceAdjustmentFields({ adjustInvoice, onToggle, adjustmentAmount }: FinanceAdjustmentFieldsProps) {
  const {
    watch,
    formState: { errors },
  } = useFormContext();
  const reasonLength = String(watch("adjustmentReason") || "").length;

  return (
    <div className="finance-adjustment-fields">
      <TextCheckBox
        text="Adjust invoice amount"
        checked={adjustInvoice}
        toolTipContent=""
        onChange={(event: { target: { checked: boolean } }) => onToggle(event.target.checked)}
      />
      {adjustInvoice && (
        <>
          <div className="finance-adjustment-row">
            <Text
              startIcon={<AttachMoneyIcon className="color-icon-secondary" />}
              name="adjustmentNewTotal"
              label="New total"
              type="number"
              minValue="0"
              size="small"
            />
            {adjustmentAmount !== null && (
              <p className="para-body-s-regular finance-adjustment-delta">
                {`Adjustment: ${formatFinanceAdjustmentAmount(adjustmentAmount)}`}
              </p>
            )}
          </div>
          <Text
            name="adjustmentReason"
            multiline
            rows={3}
            label="Reason"
            isOptional
            size="medium"
            placeholder="Why is the invoice amount changing?"
            helperTextWithoutError={errors.adjustmentReason ? "" : `${reasonLength}/500 characters`}
          />
        </>
      )}
    </div>
  );
}

export default FinanceAdjustmentFields;
